import React from "react";
import TlkTable from "../tlelrik/table/tlkTable";
import services from "../../services";
import queryString from "query-string";
import moment from "moment";
import $ from "jquery";
import TabsContaDetailsContainer from "./Tabs/TabsContaDetailsContainer";
import AcceptMovement from "./AcceptMovement";
import CreateDAA from "./CreateDAA";
import CreateIntroduzirRef from "./CreateIntroduzirRef";

let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    Page: 1,
    PageSize: 100,
};

const dateFormat = "DD-MM-YYYY HH:mm:ss";

let tablesjson = {
    MovsPendentes: {
        columnkeyMap: {
            entidadeOrigem: "Entidade",
            instalacaoVinica: "Instalação Vinica",
            produto: "Produto",
            tipoConta: "Tipo de Conta",
            nivelConta: "Nível Conta",
            estado: "Estado",
            cor: "Cor",
            anoProduto: "Ano",
            //numeroRegisto: "Registo",
            tipoMovimento: "Tipo de Movimento",
            //operacao: "Operação",
            //saldoCativo: "Saldo Cativo",
            quantidade: "Quantidade (Litros)",
            dataOperacao: "Data Mov.",
            estadoMovimento: "Situação",
        },
        actionbuttons: { CommonRedirection: "Mov Aceitar", FillTransport: "Preencher Documento" , IntroduzirRef: "Introduzir referência do eDA" }, // Redirect: "Emitir Fatura",
        listApilink: "ContaCorrente/GetMovimentosPendentes",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de movimentos pendentes ",
        Filters: {
            // typeofevaluation: "0",
            // brand: null,
            // username: null,
        },
        groupfield: [],
    },
}
const columnKeyMap = {
    entidadeOrigem: "Entidade",
    instalacaoVinica: "Instalação Vinica",
    produto: "Produto",
    tipoConta: "Tipo de Conta",
    nivelConta: "Nível Conta",
    estado: "Estado",
    cor: "Cor",
    anoProduto: "Ano",
    //numeroRegisto: "Registo",
    tipoMovimento: "Tipo de Movimento",
    //operacao: "Operação",
    //saldoCativo: "Saldo Cativo",
    quantidade: "Quantidade (Litros)",
    dataOperacao: "Data Mov.",
    estadoMovimento: "Situação",
};
const actionbuttons = { CommonRedirection: "Mov Aceitar", FillTransport: "Preencher Documento" , IntroduzirRef: "Introduzir referência do eDA" };


// const filterValue = {
//     Concelho: null,
//     DataCriadoEnd: null,
//     DataCriadoStart: null,
//     DataModificadoEnd: null,
//     DataModificadoStart: null,
//     Designacao: null,
//     Distrito: null,
//     Estado: null,
//     Fregusia: null,
//     Geocod: null,
//     NomeEntreposto: null,
//     NumInstalacao: null,
//     TipoInstalacao: null,
//     nome: null,
//     numero: null,
//     entityId: null,
// };

class MovsPendentesTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            error: null,
            showSearchMsg: false,
            totalcount: 0,
        };
    }

    componentDidMount() {
        (async () => {
            //const queryParams = queryString.parse(this.props.location.search);
            const filters = {
                // idEntidade: queryParams.entityId,
                // idInstalacaoVinica: queryParams.IDInstalacaoVinica
            };
            this.setState({
                //nif: queryParams.nif,
            });
            const response = await services.apiCall.requestApi(
                "ContaCorrente/GetMovimentosPendentes",
                filters,
                "get"
            );
            // const columnList = Object.keys(columnKeyMap).map((key) => ({
            //     field: columnKeyMap[key],
            //     columnMenuType: "checkbox",
            // }));

            var columnList = [];

            Object.keys(columnKeyMap).forEach(e => {
                if(e == "anoProduto" || e == "numeroRegisto" || e == "saldo"){
                    columnList.push({field: columnKeyMap[e], columnMenuType: "number"});
                }
                else{
                    columnList.push({field: columnKeyMap[e], columnMenuType: "checkbox"});
                }
            });

            if (response) {
                const data = response.map((entity, index) => ({
                    ...entity,
                    ...Object.keys(columnKeyMap).map((key) => {
                        if (
                            key === "saldo"
                        ) {
                            entity[columnKeyMap[key]] = services.money.format(entity[key]) || "0";
                        }
                        else if (key === "dataOperacao"){
                            entity[columnKeyMap[key]] = moment(
                                entity.dataOperacao
                            ).format(dateFormat)
                        }
                        else {
                            entity[columnKeyMap[key]] = entity[key] || "NA";
                        }
                    }),
                    selected: false,
                }));
                window.localStorage.setItem('table_total', response.length);
                this.setState({
                    data,
                    columnList,
                    totalCount: window.localStorage.getItem("table_total"),
                    loaded: true,
                },() => {
                    // console.log("Akash", "2");
                    this.createTabel();
                });
            } else {
                this.setState(() => ({
                    data: response,
                    totalCount: 0,
                    columnList,
                    loaded: false,
                }));
            }
        })();
        console.log("OI");
        this.defaultState();
    }

    componentDidUpdate = (preProp) => {
        if (
            preProp.date !== this.props.date ||
            preProp.tableName !== this.props.tableName
        ) {
            // console.log("update", this.props, preProp);
            this.defaultState();
        }
    };

    defaultState = () => {
        let linkData = { ...tablesjson };
        linkData = tablesjson[this.props.tableName];
        console.log("OI 2");
        this.setState(
            {
                linkData: linkData,
                tlkState: {
                    take: 20,
                    skip: 0,
                    group: [],
                    exporting: false,
                },
            },
            () => this.getListData()
        );
    };
    
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter };
        if (
            Request.Filters.entityId === undefined ||
            Request.Filters.entityId === ""
        ) {
            Request.Filters.entityId = null;
        }
        if (
            Request.Filters.entityname === undefined ||
            Request.Filters.entityname === ""
        ) {
            Request.Filters.entityname = null;
        }
        return Request;
    };

    getListData = async () => {
        //console.log("get list running 800");
        try {
            console.log("OI 3");
            if (!this.state.linkData) return;
            console.log("OI 4");
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,
                });
            }
            
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let res = {};
            console.log("MOVS PENDENTES");
            console.log(link);
            console.log(Request);
            console.log(method);
            res = await services.apiCall.requestApi(link, Request, method);
            console.log("ressspnseeeee", res);
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    Object.keys(columnkeyMap).map(function (key) {
                        if (key === "incorporado") {
                            _row[columnkeyMap[key]] = _row.seloIncorporado;
                        }
                        // else if(key === 'estado'){
                        //     _row['Estado'] = _row.codEstado ? 'Ativo' : 'Inativo'
                        // }
                        else if (key === "estado") {
                            _row["Estado"] = _row.estado;
                        } else if (key === "mercado") {
                            _row[columnkeyMap[key]] = _row.marcadoEspecifico;
                        }
                        // else if (key === "idRegisto") {
                        //     _row[columnkeyMap[key]] = _row.codProcesso // change this key with given key in rotulo doc
                        // }
                        else if (key === "descrição") {
                            _row[columnkeyMap[key]] =
                                _row.rotulo;
                        } else if (key === "entidade") {
                            _row[columnkeyMap[key]] = _row.idEntidade;
                        }
                        else if (key === "dataOperacao") {
                            _row[columnkeyMap[key]] = _row.dataOperacao
                                ? moment(_row.dataOperacao).format(
                                    dateFormat
                                  )
                                : "nd";
                        }
                        // else if (key === "idEntidade") {
                        //     _row[columnkeyMap[key]] = _row.nome // change this key with given key in rotulo doc
                        // }
                        else if (key === "tipo_de_processo") {
                            _row[columnkeyMap[key]] = _row.descricaos;
                        }else if (key === "quantidade") {
                            _row[columnkeyMap[key]] = services.money.format(_row.quantidade);
                        } else if (key === "n_de_correlativo") {
                            _row[columnkeyMap[key]] = _row.descricaos; // value for this should change after clearification of exact key
                        } else if (key === "n processo") {
                            _row[columnkeyMap[key]] = _row.submetidoPor || "nd";
                        } else if (key === "registo") {
                            _row[columnkeyMap[key]] = _row.numeroRegisto;
                        } else if (key === "submissão") {
                            _row[columnkeyMap[key]] = _row.dataSubmissaoPedido
                                ? moment(_row.dataSubmissaoPedido).format(
                                    dateFormat
                                  )
                                : "nd";
                        } else if (key === "ultima_verificação") {
                            // _row[columnkeyMap[key]] = _row.dataModificado || _row.dataCriado ? moment( _row.dataModificado || _row.dataCriado ).format(fullDateFormat) : "nd";
                            _row[columnkeyMap[key]] = _row.evaluation2ReviewDate || _row.lastModifiedOn ? moment(_row.evaluation2ReviewDate || _row.lastModifiedOn).format(dateFormat) : "nd";
                        } else _row[columnkeyMap[key]] = _row[key] || "nd";
                    });
                });
                // console.log("Akash", "1", res);
                window.localStorage.setItem('table_total', res.length);
                this.setState(
                    {
                        data: res,
                        filterData: res,
                        showSearchMsg: false,
                        totalcount: window.localStorage.getItem("table_total"),
                    },
                    () => {
                        // console.log("Akash", "2");
                        this.createTabel();
                    }
                );
            } else {
                this.setState({
                    showSearchMsg: true,
                    totalcount: 0,
                    telkikTable: null,
                });
            }
        } catch (error) {
            this.setState({ error });
        }
    };

    createTabel = () => {
        // console.log("Akash", "3");
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = { ...this.state.linkData.columnkeyMap };
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: "checkbox" };
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            // console.log("actionbuttons", actionbuttons);
            // console.log("filterData", this.state.filterData);

            let telkikTable = (
                <TlkTable
                    pdfTitle={this.props.title}
                    date={new Date()}
                    // generateDocument={this.state.findnonDocumentedRow === 0 ? null : this.state.linkData.generateDocument}
                    noDownloadButton={this.state.linkData.noDownloadButton}
                    // DocumentGERFIP={this.state.linkData.DocumentGERFIP}
                    actionColumnName={this.state.linkData.actionColumnName}
                    groupfield={this.state.linkData.groupfield}
                    modulename={this.state.linkData.modulename || "fordefault"}
                    notAction={this.state.linkData.notAction}
                    tlkState={this.state.tlkState}
                    deleteFunc={(id) => this.props.handleDelete(id)}
                    tableFilters={(filter) => this.tableFilters(filter)}
                    list={this.state.filterData}
                    actionbuttons={actionbuttons}
                    MainModule="Rotulo"
                    columnlist={columnlist}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );
            this.setState({
                telkikTable: telkikTable,
            });
        }
    };

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        // console.log("tlfilter",tlfilter);
        try {
            let customfilters = this.getAllFilter();
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let tlkState = { ...tlfilter };
            let data = this.makeTlkFilters(
                tlfilter,
                columnkeyMap,
                customfilters
            );
            let linkData = { ...this.state.linkData };

            // linkData.Filters = data.Filters
            this.setState(
                {
                    tlkState,
                    linkData,
                },
                () => this.getListData()
            );
        } catch (error) {
            this.setState({ error: error });
        }
        // return data;
    };

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState;
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (
            tlkfilter.filter &&
            tlkfilter.filter.filters &&
            tlkfilter.filter.filters.length > 0
        ) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value = _srow.value ? _srow.value : "";
                        checkamount = _srow.value.split(" ");
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value)
                            ? Number(_srow.value)
                            : _srow.value;
                        tkkeyvalues.push(_srow.value);
                    });
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            });
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip
            ? tlkfilter.skip / tlkfilter.take + 1
            : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC =
                tlkfilter.sort[0].dir === "asc" ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row);
        } else {
            let popUpForm = null;
        }
        if (action === "acceptMovement") {
            this.setState({
                popUpForm: ""
            })
            console.log(row);
            console.log(row["Quantidade (Litros)"]);
            console.log(this.props)
            //const params = queryString.parse(this.props.location.search);
            console.log(this)
            let popUpForm = (
                <AcceptMovement
                    instalacaoVinica={row.instalacaoVinica}
                    tipoConta={row["Tipo de Conta"]}
                    produto={row.produto}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    //idContaCorrente={params.accountId}
                    //CodEntidade={row.idEntidade}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }
        else if (action === "fillTransport") {
            this.setState({
                popUpForm: ""
            })
            console.log(row);
            console.log(row["Quantidade (Litros)"]);
            //const params = queryString.parse(this.props.location.search);
            let popUpForm = (
                <CreateDAA
                   // instalacaoVinica={this.state.entityDetail.wineInhalation}
                    //tipoConta={params.tdc}
                    //produto={params.pr}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    //idContaCorrente={params.accountId}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }
        else if (action === "IntroduzirRef") {
            this.setState({
                popUpForm: ""
            })
            //const params = queryString.parse(this.props.location.search);
            let popUpForm = (
                <CreateIntroduzirRef
                    //instalacaoVinica={this.state.entityDetail.wineInhalation}
                    //tipoConta={params.tdc}
                    //produto={params.pr}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    //idContaCorrente={params.accountId}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }

    };

    selectionChange(selection) {
        const data = [...this.state.data].map((item) => {
            if (
                selection.dataItem.codInstalacaoVinica ===
                item.codInstalacaoVinica
            ) {
                // TODO: Ask @Dart for the unique key to use here
                return { ...item, selected: true };
            } else {
                return { ...item, selected: false };
            }
        });
        this.setState({ data }, async () => {
            const queryParams = queryString.stringify({
                ...queryString.parse(this.props.location.search),
                installationId: 0,
            });
            this.props.history.push(
                `/conta_corrente/accounts_view?${queryParams}`
            );
        });
    }

    render() {
        return (
            <>
            <div className="mt-4">
                <div className="table-section custom-k-grid pt-3">
                    <div className="table-responsive">
                        {this.state.loaded && (
                            <>
                                <span>
                                    A pesquisa retornou{" "}
                                    {this.state.totalCount} registos
                                </span>
                                <TlkTable
                                    date={new Date()}
                                    list={this.state.data}
                                    modulename={"Conta Corrente"}
                                    //notAction={true}
                                    //viewFor="conta_movimento"
                                    // notGroup={true}
                                    //collepsview={true}
                                    columnlist={this.state.columnList}
                                    actionbuttons={actionbuttons}
                                    ActionPerform={(action, id) =>
                                        this.ActionPerform(action, id)
                                    }
                                    //fixTableWidth={true}
                                    //groupfield={groupfield}
                                    //toolbarHTML={ this.getToolbarHtml() }
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className="modal left-popup" id="accept-mov-left-popup">
                <div className="modal-dialog modal-sm">
                    {
                        this.state.popUpForm
                    }
                </div>
            </div>
            <div className="custom-k-grid table-section">
                <div className="table-responsive">
                    {this.state.telkikTable && (
                        <>
                            <h3>
                                {tablesjson[this.props.tableName] &&
                                tablesjson[this.props.tableName]
                                    .totalPageHeading
                                    ? tablesjson[this.props.tableName]
                                          .totalPageHeading +
                                      "(" +
                                      this.state.totalcount +
                                      ")"
                                    : `A pesquisa retornou ${this.state.totalcount} registos`}
                            </h3>
                            {this.state.telkikTable}
                        </>
                    )}
                    {this.state.totalcount == 0 && (
                        <div className="searct-found">
                            <img className="img-fluid" src="imgs/data-rotulos.png" alt="Não foram identificados registos com os critérios indicados" />
                            {this.state.showSearchMsg ? (
                                <p className="font-14">Não foram identificados registos com os critérios indicados</p>
                            ) : (
                                <h3>
                                    Pesquise uma instalação ou entidade para
                                    apresentação de mais informações
                                </h3>
                            )}
                        </div>
                    )}
                </div>
            </div>
            </>
        );
    }
}

export default MovsPendentesTab;
